(function quantityInputModule(global) {
  'use strict';

  function asFiniteNumber(value, fallback) {
    const number = Number(value);
    return Number.isFinite(number) ? number : fallback;
  }

  function getNextQuantity(value, direction, rules = {}) {
    const minimum = asFiniteNumber(rules.minimum, 1);
    const maximum = rules.maximum === '' || rules.maximum == null
      ? Number.POSITIVE_INFINITY
      : asFiniteNumber(rules.maximum, Number.POSITIVE_INFINITY);
    const increment = Math.max(asFiniteNumber(rules.increment, 1), 1);
    const current = Number(value);

    if (!Number.isFinite(current)) return minimum;

    const currentStep = (current - minimum) / increment;
    const nextStep = direction < 0 ? Math.ceil(currentStep) - 1 : Math.floor(currentStep) + 1;
    const highestStep = Number.isFinite(maximum)
      ? Math.max(Math.floor((maximum - minimum) / increment), 0)
      : Number.POSITIVE_INFINITY;
    const boundedStep = Math.min(Math.max(nextStep, 0), highestStep);

    return minimum + boundedStep * increment;
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { getNextQuantity };
  }

  if (!global.document) return;

  const guard = Symbol.for('store-builder.quantity-input');
  if (global[guard]) return;
  global[guard] = true;
  document.documentElement.setAttribute('data-quantity-enhanced', '');

  function getRules(input) {
    return {
      minimum: input.min,
      maximum: input.max,
      increment: input.step,
    };
  }

  function updateButtons(control) {
    const input = control.querySelector('.quantity-input__field');
    if (!input) return;

    const decrease = control.querySelector('[data-quantity-decrease]');
    const increase = control.querySelector('[data-quantity-increase]');
    const value = asFiniteNumber(input.value, asFiniteNumber(input.min, 1));

    if (decrease) {
      decrease.disabled = input.disabled || getNextQuantity(value, -1, getRules(input)) === value;
    }

    if (increase) {
      increase.disabled = input.disabled || getNextQuantity(value, 1, getRules(input)) === value;
    }
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-quantity-decrease], [data-quantity-increase]');
    if (!button || button.disabled) return;

    const control = button.closest('[data-quantity-input]');
    const input = control?.querySelector('.quantity-input__field');
    if (!input) return;

    const direction = button.hasAttribute('data-quantity-decrease') ? -1 : 1;
    const next = getNextQuantity(input.value, direction, getRules(input));
    if (String(next) === input.value) return;

    input.value = String(next);
    updateButtons(control);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('input', (event) => {
    const control = event.target.closest('[data-quantity-input]');
    if (control) updateButtons(control);
  });

  document.addEventListener('cart:render', (event) => {
    const scope = event.detail?.root || document;
    scope.querySelectorAll('[data-quantity-input]').forEach(updateButtons);
  });
})(typeof window !== 'undefined' ? window : globalThis);
